import Vue from 'vue'
import Router from 'vue-router'


// 登录
import Login from '@/components/Page/Login/Login'
// 仪表盘
import Map from '@/components/Map'
// 主页
import Index from '@/components/Index'

// 其他
import LoginSetting from '@/components/Page/Other/LoginSetting'
import ModifyPassword from '@/components/Page/Other/ModifyPassword'

/* 设备管理 */
// 生产列表
import ProductList from '@/components/Page/DeviceManage/ProductList/SIndex'
import Output from '@/components/Page/DeviceManage/ProductList/Output'
import ViewLog from '@/components/Page/DeviceManage/ProductList/ViewLog'
import ConfigMainboard from '@/components/Page/DeviceManage/ProductList/ConfigMainboard'
import BoxConfig from '@/components/Page/DeviceManage/ProductList/BoxConfig'

// 协议管理
import ProtocolManage from '@/components/Page/DeviceManage/ProtocolManage'

// 模板管理
import InfoTemplate from '@/components/Page/TemplateManage/InfoTemplate'
import smsLog from '@/components/Page/TemplateManage/smsLog'

// 客户管理
import ClientList from '@/components/Page/ClientManage/ClientList'
import ClientAuthAllot from '@/components/Page/ClientManage/ClientAuthAllot'

// 平台运维
import ClientMaintain from '@/components/Page/Maintain/ClientMaintain'
import ServerMaintain from '@/components/Page/Maintain/ServerMaintain'
import ServerManage from '@/components/Page/Maintain/ServerManage/SIndex'
import OperateServer from '@/components/Page/Maintain/ServerManage/OperateServer'
import BusinessPlan from '@/components/Page/Maintain/BusinessPlan/SIndex'
import BillingInfo from '@/components/Page/Maintain/BusinessPlan/BillingInfo'
import DeviceMaintain from '@/components/Page/Maintain/DeviceMaintain/SIndex'
import ErrorLog from '@/components/Page/Maintain/DeviceMaintain/ErrorLog'
import OperateBox from '@/components/Page/Maintain/DeviceMaintain/OperateBox'

// 系统
import StaffManage from '@/components/Page/System/StaffManage/SIndex'
import AuthAllot from '@/components/Page/System/StaffManage/AuthAllot'
import DictionaryManage from '@/components/Page/System/DictionaryManage' // 产品字典
import ThirdDictionaryManage from '@/components/Page/System/ThirdDictionaryManage' // 第三方产品字典
import LogManage from '@/components/Page/System/LogManage'
import ModuleManage from '@/components/Page/System/ModuleManage'
import ThirdApplication from '@/components/Page/System/ThirdApplication' // 第三方应用
import APIManage from '@/components/Page/System/APIManage'
import OnlineUpdate from '@/components/Page/System/OnlineUpdate/OnlineUpdate' // 在线升级
import updateLog from '@/components/Page/System/OnlineUpdate/updateLog' // 更新记录
import timedTasks from '@/components/Page/System/timedTasks'  // 定时任务
import AddressSet from '@/components/Page/System/AddressSet' // 地址参数设置

Vue.use(Router)

export default new Router({
  routes: [
    // 登录
    {
      path: '/',
      name: 'Login',
      component: Login
    },

    // 仪表盘，即 地图
    {
      path: '/Map/',
      name: 'Map',
      component: Map
    },

    {
      path: '/Map/:mapLevel/:id',
      name: 'MapRoute',
      component: Map
    },

    // 首页
    {
      path: '/Index/',
      name: 'Index',
      component: Index
    },

    // 其他
    {
      path: '/LoginSetting/',
      name: 'LoginSetting',
      component: LoginSetting
    },

    {
      path: '/ModifyPassword/',
      name: 'ModifyPassword',
      component: ModifyPassword
    },

    /* 设备管理 */
    // 生产列表
    {
      path: '/ProductList/',
      name: 'ProductList',
      component: ProductList
    },

    {
      path: '/Output/',
      name: 'Output',
      component: Output
    },

    {
      path: '/ViewLog/',
      name: 'ViewLog',
      component: ViewLog
    },

    {
      path: '/ConfigMainboard/',
      name: 'ConfigMainboard',
      component: ConfigMainboard
    },

    {
      path: '/BoxConfig/',
      name: 'BoxConfig',
      component: BoxConfig
    },

    // 协议管理
    {
      path: '/ProtocolManage/',
      name: 'ProtocolManage',
      component: ProtocolManage
    },

    // 模板管理
    {
      path: '/InfoTemplate/',
      name: 'InfoTemplate',
      component: InfoTemplate
    },

    {
      path: '/smsLog/',
      name: 'smsLog',
      component: smsLog
    },

    // 客户管理
    {
      path: '/ClientList/',
      name: 'ClientList',
      component: ClientList
    },

    {
      path: '/ClientAuthAllot/',
      name: 'ClientAuthAllot',
      component: ClientAuthAllot
    },

    /* 平台运维 */
    // 客户运维
    {
      path: '/ClientMaintain/',
      name: 'ClientMaintain',
      component: ClientMaintain
    },

    // 设备运维
    {
      path: '/DeviceMaintain/',
      name: 'DeviceMaintain',
      component: DeviceMaintain
    },

    {
      path: '/ErrorLog/',
      name: 'ErrorLog',
      component: ErrorLog
    },

    {
      path: '/OperateBox/',
      name: 'OperateBox',
      component: OperateBox
    },

    // 服务器运维
    {
      path: '/ServerMaintain/',
      name: 'ServerMaintain',
      component: ServerMaintain
    },

    // 服务器管理
    {
      path: '/ServerManage/',
      name: 'ServerManage',
      component: ServerManage
    },

    {
      path: '/OperateServer/',
      name: 'OperateServer',
      component: OperateServer
    },

    // 企业套餐
    {
      path: '/BusinessPlan/',
      name: 'BusinessPlan',
      component: BusinessPlan
    },

    {
      path: '/BillingInfo/',
      name: 'BillingInfo',
      component: BillingInfo
    },

    // 系统
    // 员工管理
    {
      path: '/StaffManage/',
      name: 'StaffManage',
      component: StaffManage
    },
 
    {
      path: '/AuthAllot/',
      name: 'AuthAllot',
      component: AuthAllot
    },

    {
      path: '/DictionaryManage/',
      name: 'DictionaryManage',
      component: DictionaryManage
    },

    {
      path: '/ThirdDictionaryManage/',
      name: 'ThirdDictionaryManage',
      component: ThirdDictionaryManage
    },
 
    {
      path: '/LogManage/',
      name: 'LogManage',
      component: LogManage
    },

    {
      path: '/ModuleManage/',
      name: 'ModuleManage',
      component: ModuleManage
    },

    {
      path: '/ThirdApplication/',
      name: 'ThirdApplication',
      component: ThirdApplication
    },

    {
      path: '/APIManage/',
      name: 'APIManage',
      component: APIManage
    },

    {
      path: '/OnlineUpdate/',
      name: 'OnlineUpdate',
      component: OnlineUpdate
    },

    {
      path: '/updateLog/',
      name: 'updateLog',
      component: updateLog,
    },

    {
      path: '/timedTasks/',
      name: 'timedTasks',
      component: timedTasks,
    },

    { // 地址参数设置
      path: '/AddressSet/',
      name: 'AddressSet',
      component: AddressSet,
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js